import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const FAQSection = ({ language }) => {
  const [openIndex, setOpenIndex] = useState(null);

  const content = {
    en: {
      title: 'Frequently Asked Questions',
      subtitle: 'Quick answers to common inquiries',
      faqs: [
        {
          question: 'What is the minimum order quantity for coffee beans?',
          answer: 'Our minimum order quantity is typically 1 container (approximately 18-20 tons). However, we can accommodate smaller orders for sample testing. Please contact our sales team for specific requirements.'
        },
        {
          question: 'How long does shipping take to China?',
          answer: 'Standard shipping from African origins to Chinese ports takes approximately 30-45 days depending on the origin country and destination port. We provide full tracking and documentation throughout the shipping process.'
        },
        {
          question: 'Do you provide quality certificates and test reports?',
          answer: 'Yes, all our coffee beans come with comprehensive quality certificates, cupping reports, and laboratory test results. These documents are available for download on each product page and are included with every shipment.'
        },
        {
          question: 'Can I visit the coffee farms before placing an order?',
          answer: 'Absolutely! We encourage buyers to visit our partner farms. We can arrange farm visits and provide local support. Please contact us at least 2 weeks in advance to coordinate the visit.'
        },
        {
          question: 'What payment methods do you accept?',
          answer: 'We accept Letter of Credit (L/C), Telegraphic Transfer (T/T), and other internationally recognized payment methods. Payment terms are negotiable based on order size and buyer relationship.'
        },
        {
          question: 'How do I become a registered supplier on your platform?',
          answer: 'To become a supplier, please submit an application through our contact form selecting "Supplier Application". Our team will review your application and contact you within 3-5 business days with next steps.'
        }
      ]
    },
    zh: {
      title: '常见问题',
      subtitle: '常见咨询的快速答案',
      faqs: [
        {
          question: '咖啡豆的最小订购量是多少？',
          answer: '我们的最小订购量通常为1个集装箱（约18-20吨）。但是，我们可以为样品测试提供较小的订单。请联系我们的销售团队了解具体要求。'
        },
        {
          question: '运送到中国需要多长时间？',
          answer: '从非洲产地到中国港口的标准运输时间约为30-45天，具体取决于原产国和目的港。我们在整个运输过程中提供完整的跟踪和文档。'
        },
        {
          question: '你们提供质量证书和测试报告吗？',
          answer: '是的，我们所有的咖啡豆都附有全面的质量证书、杯测报告和实验室测试结果。这些文件可在每个产品页面上下载，并随每批货物一起提供。'
        },
        {
          question: '下订单前我可以参观咖啡农场吗？',
          answer: '当然可以！我们鼓励买家参观我们的合作农场。我们可以安排农场参观并提供当地支持。请至少提前2周联系我们以协调参观。'
        },
        {
          question: '你们接受哪些付款方式？',
          answer: '我们接受信用证（L/C）、电汇（T/T）和其他国际认可的付款方式。付款条款可根据订单规模和买家关系进行协商。'
        },
        {
          question: '我如何成为您平台上的注册供应商？',
          answer: '要成为供应商，请通过我们的联系表格提交申请，选择"供应商申请"。我们的团队将审核您的申请，并在3-5个工作日内与您联系后续步骤。'
        }
      ]
    }
  };

  const t = content?.[language];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="bg-card rounded-lg border border-border p-6 lg:p-8">
      <div className="mb-6">
        <h2 className="text-2xl font-heading font-semibold text-foreground mb-2">
          {t?.title}
        </h2>
        <p className="text-muted-foreground">
          {t?.subtitle}
        </p>
      </div>
      <div className="space-y-3">
        {t?.faqs?.map((faq, index) => (
          <div
            key={index}
            className="border border-border rounded-lg overflow-hidden transition-smooth"
          >
            <button
              onClick={() => toggleFAQ(index)}
              className="w-full flex items-center justify-between p-4 text-left hover:bg-muted transition-smooth"
            >
              <span className="font-medium text-foreground pr-4">
                {faq?.question}
              </span>
              <Icon
                name={openIndex === index ? 'ChevronUp' : 'ChevronDown'}
                size={20}
                className="flex-shrink-0 text-muted-foreground"
              />
            </button>
            {openIndex === index && (
              <div className="px-4 pb-4 pt-0">
                <p className="text-sm text-muted-foreground leading-relaxed">
                  {faq?.answer}
                </p>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQSection;